import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Briefcase } from 'lucide-react';
import { CollapsibleSection } from './IntelligenceUIComponents';

const CategoryRow = ({ category, potential, readiness }) => (
  <div className="flex items-center justify-between p-3 bg-muted/20 rounded-lg">
    <span className="text-sm font-medium">{category}</span>
    <div className="flex items-center gap-3">
      <span className="text-sm text-stable">{potential}</span>
      <div className="w-16 h-2 bg-muted/30 rounded-full overflow-hidden">
        <div className="h-full bg-stable rounded-full" style={{ width: `${readiness}%` }} />
      </div>
    </div>
  </div>
);

export const CommercialPositioningSection = ({ data }) => {
  const cp = data?.commercialPositioning;
  if (!cp) return null;
  
  const cats = cp.sponsorshipLeverage.potentialCategories || [];
  const se = cp.speakingEngagements;
  const topics = se.topicDemand || [];
  
  return (
    <CollapsibleSection title="Commercial & Institutional Positioning" icon={Briefcase} defaultOpen={true} badge="Monetization">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div>
          <h3 className="text-xs text-muted-foreground uppercase tracking-wider mb-3">Sponsorship Opportunities</h3>
          <div className="space-y-2">
            {cats[0] && <CategoryRow {...cats[0]} />}
            {cats[1] && <CategoryRow {...cats[1]} />}
            {cats[2] && <CategoryRow {...cats[2]} />}
            {cats[3] && <CategoryRow {...cats[3]} />}
          </div>
        </div>
        <div>
          <h3 className="text-xs text-muted-foreground uppercase tracking-wider mb-3">Speaking Engagements</h3>
          <Card className="bg-stable/5 border-stable/20">
            <CardContent className="p-4">
              <p className="text-xs text-muted-foreground">Market Rate</p>
              <p className="text-xl font-bold text-stable">{se.marketRate}</p>
              <p className="text-xs text-muted-foreground mt-2">Annual Potential</p>
              <p className="text-lg font-semibold">{se.annualPotential}</p>
            </CardContent>
          </Card>
          <div className="mt-3 flex flex-wrap gap-2">
            {topics[0] && <Badge variant="outline" className="text-xs">{topics[0]}</Badge>}
            {topics[1] && <Badge variant="outline" className="text-xs">{topics[1]}</Badge>}
            {topics[2] && <Badge variant="outline" className="text-xs">{topics[2]}</Badge>}
            {topics[3] && <Badge variant="outline" className="text-xs">{topics[3]}</Badge>}
          </div>
        </div>
      </div>
    </CollapsibleSection>
  );
};

export default CommercialPositioningSection;
